import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import CameraSetRepository from "../../../repositories/CameraSetRepository";
import {
    ActionButtons,
    ActionButtonTypes,
    buildActionButton
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";

const CameraSetListView = () => {

	const navigate = useNavigate();
	const repository = new CameraSetRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/camera-sets/" + event.Id);
    }

	const {items, totalCount, itemsOnPage, onDeleteHandler, onEditHandler, onPage, isSearching, onFilterChangedHandler, onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
      { field: 'Id', headerName: t('ID'), width: 70, sortable: false },
      { field: 'ParkingZoneName', headerName: t('Parking zone'), width: 200, sortable: false  },
      {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler), buildActionButton(ActionButtonTypes.DELETE, t("Delete"), onDeleteHandler)])
      }
    ];

	return (
	    <GridSkeleton title={t("Camera sets")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort} />)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default CameraSetListView;